<template>
  <vip-sonko-layout>
    <v-layout wrap>
      <v-flex xs12 class="mx-3">
        <v-toolbar flat dense color="toolbarColor">My Payments</v-toolbar>
      </v-flex>

      <v-flex xs12 class="mx-3">
        <v-data-table
          :headers="headers"
          :items="payments"
          :pagination.sync="pagination"
        >
          <template v-slot:items="props">
            <td>{{ props.item.packageName }}</td>
            <td>Kshs. {{ props.item.cost}} /=</td>
            <td>{{ props.item.date | moment("Do MMM YYYY") }}</td>
          </template>
          <v-alert
            v-slot:no-results
            :value="true"
            color="error"
            icon="warning"
          >No results.</v-alert>
        </v-data-table>
      </v-flex>
    </v-layout>
  </vip-sonko-layout>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "PaymentsIndex",
  computed: {
    ...mapGetters(["user"])
  },
  data() {
    return {
      pagination: {
        rowsPerPage: 15
      },
      payments: [],
      headers: [
        {
          text: "Package Name",
          align: "left",
          sortable: false,
          value: "title"
        },
        {
          text: "Amount",
          align: "left",
          sortable: false,
          value: "cost"
        },
        {
          text: "Date",
          align: "left",
          sortable: false,
          value: "date"
        }
      ]
    };
  },
  created() {
    const user = this.user;
    this.$store.dispatch("get", "/payment/find/" + user._id).then(res => {
      if (res.state) {
        this.payments = res.payments;
      }
    });
  }
};
</script>
